import React from "react";

import { bugsnagClient } from "@internal/analytics";

const plugin = bugsnagClient.getPlugin("react");
if (!plugin) {
  throw new Error(
    "Bugsnag client unexpectedly returned undefined for React plugin.",
  );
}
export const ErrorBoundary = plugin.createErrorBoundary(React);
